import React from 'react';
import { createIcon } from './create-icon';
import './icon-caret-left.scss';

export const IconCaretLeft = createIcon(<div className="icon-caret-left" />);
